import styled from "styled-components"

export const CrouselButtonWrapper = styled.div`
  
   margin-top:40px;
 h1{
  font-weight:700;
  font-size:38px;
 }
  img {
    cursor:pointer;
    margin-top:30px;
    align-items:center;
    height:65px;
    object-fit: cover;
    object-position:center;
    width:85%;
    padding-left:30px;
    border-radius: 4px;
  
  }
`;

export const ButtonSpecialImage = styled.img``;
